namespace RioERP.Masters {
    export namespace Rioplay8AllowedDevicesService {
        export const baseUrl = 'Masters/Rioplay8AllowedDevices';

        export declare function Create(request: Serenity.SaveRequest<Rioplay8AllowedDevicesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<Rioplay8AllowedDevicesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<Rioplay8AllowedDevicesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<Rioplay8AllowedDevicesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Masters/Rioplay8AllowedDevices/Create",
            Update = "Masters/Rioplay8AllowedDevices/Update",
            Delete = "Masters/Rioplay8AllowedDevices/Delete",
            Retrieve = "Masters/Rioplay8AllowedDevices/Retrieve",
            List = "Masters/Rioplay8AllowedDevices/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>Rioplay8AllowedDevicesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
